/**
 * @file The dedup keys one staged entry occupies. Consumers: `planSignifyFetchJobAdditions` and
 * `useSignifyFetchJobDraft`, which hold the invariant "no two staged inputs share a key".
 * A pasted token contributes its normalised text; a search pick contributes its 12NC and its
 * commercial code as well, so pasting either of those after picking the product is caught here.
 * What this cannot catch — a UPC, a 6NC or an alternative material code for a product already in the
 * list — only resolution knows, so both inputs are fetched and `useSignifyFetchJobInsert` catches
 * them at insert time: its held set collapses parts sharing one resolved identity into one row.
 */

import type { SignifyFetchJobDraftEntry } from '../../index.types';

const normalise = (value: string): string => value.trim().replace(/\s+/g, ' ').toUpperCase();

export function signifyFetchJobInputKeys(
  entry: Pick<SignifyFetchJobDraftEntry, 'input' | 'product'>,
): string[] {
  const keys = [
    normalise(entry.input),
    ...(entry.product ? [normalise(entry.product.code), normalise(entry.product.commercialCode)] : []),
  ];
  return Array.from(new Set(keys.filter((key) => key.length > 0)));
}
